import { error } from "console";
import { ADMIN_FETCH_OWNER_FILMS, ADMIN_FETCH_USER_FILMS, ADMIN_UNDELETE_FILM } from "./actions";

interface UsersState {
  loading: boolean;
  films: any[];
  ownedFilms?: any[];
  errors?: any;
}

const defaultState: UsersState = {
  loading: false,
  films: [],
  ownedFilms: [],
  errors: null
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case ADMIN_FETCH_USER_FILMS + "_PENDING": {
      return {
        ...state,
        errors: null,
        loading: true
      };
    }

    case ADMIN_FETCH_USER_FILMS + "_FULFILLED": {
      return {
        ...state,
        films: action.payload.data.films,
        loading: false
      };
    }

    case ADMIN_FETCH_USER_FILMS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case ADMIN_FETCH_OWNER_FILMS + "_PENDING": {
      return {
        ...state,
        errors: null,
        loading: true
      };
    }

    case ADMIN_FETCH_OWNER_FILMS + "_FULFILLED": {
      return {
        ...state,
        ownedFilms: action.payload.data.films,
        loading: false
      };
    }

    case ADMIN_FETCH_OWNER_FILMS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    case ADMIN_UNDELETE_FILM + "_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case ADMIN_UNDELETE_FILM + "_FULFILLED": {
      return {
        ...state,
        loading: false
      };
    }

    case ADMIN_UNDELETE_FILM + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
